import request from './request'

// 服务费角色（字典表）管理接口
export function getCommissionRoles(params) {
  return request.get('/admin/commission-roles', { params })
}

export function getCommissionRoleOptions() {
  return request.get('/admin/commission-allocation-rules/options')
}

export function getCommissionRole(id) {
  return request.get(`/admin/commission-roles/${id}`)
}

export function createCommissionRole(data) {
  return request.post('/admin/commission-roles', data)
}

export function updateCommissionRole(id, data) {
  return request.put(`/admin/commission-roles/${id}`, data)
}

export function deleteCommissionRole(id) {
  return request.delete(`/admin/commission-roles/${id}`)
}
